import { SvgIcon as MuiSvgIcon } from "@material-ui/core";
import { ComponentProps } from "react";
import { Color } from "../../theme/color";

export function SendIcon(props: ComponentProps<typeof MuiSvgIcon> & { blank?: boolean }) {
  if (props.blank) {
    return (
      <MuiSvgIcon viewBox="0 0 16 15" htmlColor={Color.Body} {...props}>
        <path d="M12.4817 8.55907L3.17659 12.4821C2.97575 12.5625 2.78494 12.5452 2.60417 12.4302C2.4234 12.3152 2.33301 12.1484 2.33301 11.9296V4.07065C2.33301 3.85184 2.4234 3.68496 2.60417 3.57C2.78494 3.45505 2.97575 3.43774 3.17659 3.51809L12.4817 7.44114C12.7295 7.55054 12.8534 7.73686 12.8534 8.0001C12.8534 8.26335 12.7295 8.44967 12.4817 8.55907ZM3.33299 11.3334L11.233 8.0001L3.33299 4.66677V7.12832L6.94834 8.0001L3.33299 8.87189V11.3334Z" />
      </MuiSvgIcon>
    );
  }

  return (
    <MuiSvgIcon viewBox="0 0 16 15" htmlColor={Color.Body} {...props}>
      <path d="M1.4541 14.2995C1.15202 14.4202 0.8654 14.3945 0.59425 14.2225C0.323083 14.0505 0.1875 13.7999 0.1875 13.4709L0.1875 9.24975L7.1105 7.5767L0.1875 5.90365L0.1875 1.68253C0.1875 1.35346 0.323083 1.10293 0.59425 0.930926C0.8654 0.75891 1.15202 0.733252 1.4541 0.853952L15.4105 6.73825C15.7823 6.90478 15.9681 7.18488 15.9681 7.57853C15.9681 7.97218 15.7823 8.25105 15.4105 8.41515L1.4541 14.2995Z" />
    </MuiSvgIcon>
  );
}
export default SendIcon;
